import { Link } from "react-router-dom";
import type { Film } from "@/types/film";
import { typeLabels } from "@/lib/films";

interface FilmCardProps {
  film: Film;
  showType?: boolean;
}

export default function FilmCard({ film, showType = false }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className="group block cursor-pointer"
      aria-label={`${film.title} 详情`}
    >
      <div className="poster-frame relative aspect-[2/3] w-full overflow-hidden rounded-lg">
        <img
          src={film.poster}
          alt={`${film.title} 海报`}
          title={`${film.title} 电影海报`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.06]"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent opacity-90" />

        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-foreground-950/70 px-1.5 py-1 text-[11px] font-semibold text-background-50 backdrop-blur-sm">
          <i className="ri-star-fill text-accent-400" />
          {film.rating.toFixed(1)}
        </span>

        {showType && (
          <span className="absolute left-2 top-2 rounded-md bg-accent-500 px-1.5 py-1 text-[10px] font-semibold text-background-50">
            {typeLabels[film.type]}
          </span>
        )}

        <div className="absolute inset-x-0 bottom-0 p-3">
          <div className="flex flex-wrap gap-1.5">
            {film.genres.slice(0, 2).map((genre) => (
              <span
                key={genre}
                className="rounded border border-background-50/25 px-1.5 py-0.5 text-[10px] text-background-100"
              >
                {genre}
              </span>
            ))}
          </div>
          <p className="mt-2 line-clamp-1 text-[11px] text-background-200/80">
            {film.year} · {film.region}
          </p>
        </div>

        <div className="absolute inset-0 flex items-center justify-center bg-foreground-950/35 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-primary-700">
            <i className="ri-arrow-right-up-line text-lg" />
          </span>
        </div>
      </div>

      <h3 className="mt-3 line-clamp-1 text-[15px] font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
        {film.title}
      </h3>
      <p className="mt-1 line-clamp-1 text-xs text-foreground-600">
        {film.director} 导演 · {film.cast.slice(0, 2).join(" / ")}
      </p>
    </Link>
  );
}